module.exports = __webpack_public_path__ + "assets/img/Structure_item8.9a3f4f05.png";